// Local development uses the React server proxy to reach the hosted PHP API.
export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? '/Citations/PHP/'
  : 'https://www.lgfantasy.ca/Citations/PHP/';

// Uploaded file paths are relative to the PHP directory, even with a leading slash.
export const getUploadedImageUrl = (imagePath) => {
  if (typeof imagePath !== 'string' || !imagePath.trim()) return '';
  const path = imagePath.trim();
  if (/^(https?:|data:|blob:)/i.test(path) || path.startsWith('//')) return path;
  if (/^\/?Citations\/PHP\//i.test(path)) return '/' + path.replace(/^\/+/, '');
  return API_BASE_URL + path.replace(/^(\.\/|\/)+/, '');
};
